import { client } from './client'
import Macrotag from '../models/macrotag'

export default {
  index (query) {
    return client.get('/macrotags?include=microtags', {
      params: query
    })
  },
  show (id) {
    return client.get('/macrotags/' + id)
      .then((response) => {
        return new Macrotag(response.data.data)
      })
  },
  store (data) {
    return client.post('/macrotags', data.prepareForSend())
  },
  update (id, data) {
    return client.patch('/macrotags/' + id, data.prepareForSend())
  },
  search (data, query) {
    return client.get('/macrotags', {
      params: {
        filter: JSON.stringify(data),
        limit: query.limit,
        ascending: query.ascending,
        page: query.page,
        byColumn: query.byColumn,
        orderBy: query.orderBy
      }
    })
  },
  select (data) {
    let macrotag = new Macrotag()
    macrotag.macrotag = data
    return client.get('/macrotags', {
      params: {
        filter: JSON.stringify(macrotag),
        limit: 100,
        orderBy: 'macrotag'
      }
    })
  },
  delete (id) {
    return client.delete('/macrotags/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/api/macrotags.js